<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Emigreren? Vergelijk offertes!</h1>
      <p>
        Als u een verhuizing naar het buitenland in het vooruitzicht heeft,
        moeten er tientallen zaken worden geregeld. Misschien heeft u door alle
        drukte de neiging om in zee te gaan met het eerste het beste
        verhuisbedrijf dat u tegenkomt in het telefoonboek. Een grote fout! Door
        tarieven van verschillende internationale verhuizers naast elkaar te
        leggen en de offertes goed te bestuderen, kunt u tot honderden euro’s
        besparen tijdens het emigreren. Alleverhuizers.nl biedt u daarom de
        mogelijk om gratis meerdere offertes aan te vragen van diverse
        verhuisbedrijven, zodat u op basis van die informatie een weloverwogen
        keuze kunt maken. Maak uw verhuizing naar het buitenland niet nóg
        duurder en ingewikkelder en vergelijk gratis offertes via deze website!
      </p>

      <h2>Begin op tijd</h2>
      <p>
        Omdat emigreren nogal wat organisatie vergt, kunt u niet vroeg genoeg
        beginnen met de voorbereidingen. Vraag bijvoorbeeld maanden van tevoren
        offertes aan via deze website, zodat u alle tijd heeft om u te verdiepen
        in de tarieven en voorwaarden van de verschillende verhuisbedrijven. Het
        kiezen van de juiste verhuizers kan u zeker honderden euro’s schelen;
        niet alleen vanwege het verschil in de tarieven, maar ook bijvoorbeeld
        door afwijkende garantievoorwaarden. Neem dus geen overhaaste
        beslissingen wanneer u gaat emigreren en begin met het vergelijken van
        diverse offertes!
      </p>

      <h2>Emigreren en vergelijken: hoe werkt het?</h2>
      <p>
        Het enige wat u hoeft te doen, is het invullen van enkele persoonlijke
        gegevens en informatie die betrekking heeft op de verhuizing en de
        verpakking. Wij zorgen er vervolgens voor dat u zo snel mogelijk in het
        bezit bent van offertes van verschillende
        <nuxt-link to="/"> verhuisbedrijven </nuxt-link>, en de rest laten we
        uiteraard aan u over. Hoe simpel en voordelig wilt u het hebben? Doe uw
        voordeel met deze slimme constructie en bespaar tot honderden euro’s als
        u gaat emigreren!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Emigreren? Vergelijk offertes van internationale verhuizers!',
      headDescription:
        'Sta je op het punt om te gaan emigreren? Op Alleverhuizers.nl heb je de mogelijkheid om gratis offertes te vergelijken van internationale verhuizers!',
    }
  },
}
</script>
